function formatProbationDate(value) {
  if (value == null || value === '') return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function getProbationFromAccount(data) {
  if (!data || typeof data !== 'object') {
    return { onProbation: null, completionDate: '' };
  }

  const probationCompleted = data.probation_completed;

  return {
    onProbation:
      typeof probationCompleted === 'boolean' ? !probationCompleted : null,
    completionDate: data.probation_completed_at || '',
  };
}

export function getProbationDisplay(onProbation, completionDate) {
  const isOnProbation = onProbation === true;
  const isOffProbation = onProbation === false;

  return {
    onProbationLabel:
      onProbation == null ? '—' : isOnProbation ? 'Yes' : 'Completed',
    completionDateLabel: isOnProbation
      ? 'N/A'
      : isOffProbation
        ? formatProbationDate(completionDate)
        : '—',
    isOnProbation,
    isOffProbation,
  };
}
